import { Link, useLocation } from 'react-router-dom';
import * as z from 'zod';
import progressAnimation from '@/assets/animation/blue_dog_loader.json';
import Lottie from 'lottie-react';
import { Button } from '@/components/Elements';
import { useAuth } from '@/lib/auth';
import { GOOGLE_CLIENT_ID, HOST_URL, SCOPE, API_URL } from '@/config';
import moment from 'moment-timezone';
import { ChangeEvent, useEffect, useState } from 'react';
import { showNotification } from '@/utils/notificationUtils';
import { Header } from '@/features/availability/components/Header';
import {SimpleHeader} from '@/features/availability/components/SimpleHeader'
import Utils from '@/utils/util';
let myWindow: any;
type LoginFormProps = {
  onBackClick?: () => void;
  onSuccess?: () => void;
  requiredEmailVerification?: () => void;
  onForgotPasswordPage?:()=>void;
};
export const Login = ({ onBackClick,onSuccess,requiredEmailVerification,onForgotPasswordPage }: LoginFormProps) => {
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmial] = useState('');
  const [password, setPassword] = useState('');
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'email') {
      setEmial(event.target.value);
    }
    else if (event.target.id === 'password') {
      setPassword(event.target.value);
    }
  };

  const validate = () => {
    if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      showNotification({
        type: 'info',
        title: 'Please enter valid email',
      });
      return false;
    } 
    else if (!password) {
      showNotification({
        type: 'info',
        title: 'Please enter password',
      });
      return false;
    }
    return true;
  };
  return (
    <div className="full-height">
        <div className="top-cotent">
      {/* <Header
        onBackClick={() => {
          if(onBackClick)
          {
          onBackClick();
          }
        }}
      /> */}
        <SimpleHeader
        onBackClick={() => {
          if(onBackClick)
          {
          onBackClick();
          }
        }}
        screenTitle="Login"
      />
      
      <div className="page-cotent-title"></div>
      <div className='signup-input-tab'>
      <div className="input-out-block">
        <input
          id="email"
          type="email"
          value={email}
          className="cust-input-mobile"
          onChange={handleChange}
          placeholder="Enter your email"
        />
      </div>
      <div className="input-out-block">
        <input
          id="password"
          type="password"
          value={password}
          className="cust-input-mobile"
          onChange={handleChange}
          placeholder="Enter your password"
        />
      </div>
      </div>
      </div>
      <div className='already-login forgot-pass'>
        <a
          onClick={() => {
            if(onForgotPasswordPage){
              onForgotPasswordPage();
            }
          }}
          className="link"
        >
          FORGOT PASSWORD
        </a>
      </div>
      <div className='footer-btn-container'>
      <Button
        type="button"
        variant="primary"
        className="w-full inline-flex justify-center rounded-md border profile-new-btn"
        onClick={async()=>{
          if (validate()) {
            try {
              await login({
                email,
                password,
              });
              if (onSuccess) {
                localStorage.setItem("UsersEmail",email)
                onSuccess();
              }
            } catch (error: any) {
              if (
                (error && error.response && error.response.data && error.response.data.message) ||
                (error && error.message)
              ) {
                let message = error.response?.data?.message || error.message;
                let errorcode;
                if (error?.response?.data?.errors && error?.response?.data?.errors?.length > 0) {
                  message = `${error.response?.data?.errors[0]?.message}`;
                  errorcode=error.response?.data?.errors[0]?.code;
                  if (message.includes('field is required') > 0) {
                    message = `${error.response?.data?.errors[0]?.field} ${error.response?.data?.errors[0]?.message}`;
                  }
                }
               if(errorcode&&errorcode==='ERR067'&&requiredEmailVerification)
               {
                localStorage.setItem("UsersEmail",email)
                requiredEmailVerification();
               }
              }
             
            }
           
          }

        }}
      >
        Continue
      </Button>
      </div>
    </div>
  );
};
